import { useCallback, useEffect, useState } from "react";
import {
  DEFAULT_CURRENCY_FOR_EURO_OR_USD,
  DEFAULT_CURRENCY_FOR_ILS,
} from "../constants/constants";
import useCurrentCurrency from "components/Pages/Plans/Utils/useCurrentCurrency";
import { CurrencySymbolE } from "components/Pages/Purchases_new/models/enums";
import DonationModal from "./DonationModal/DonationModal";
import PurchaseModal from "./PurchaseModal/PurchaseModal";
import ThanksFormModal from "./ThanksFormModal/ThanksFormModal";

interface ThanksActionModalsI {
  firstModalId: "amount-for-thanks" | "complete-purchase" | "thanks-form-modal";
}

type PaymentSuccessEventDataT = {
  PelecardTransactionId: number;
  PaymentId: number;
  CardHolderID: number;
  CreditCardNumber: number;
  CreditCardBrand: string;
  CardHolderName: string;
  ConfirmationKey: number;
};

const ThanksActionModals = ({ firstModalId }: ThanksActionModalsI) => {
  const currency = useCurrentCurrency();

  const currentCurrency =
    CurrencySymbolE[currency as keyof typeof CurrencySymbolE];

  const defaultCurrentCurrency =
    currentCurrency === CurrencySymbolE.ILS
      ? DEFAULT_CURRENCY_FOR_ILS
      : DEFAULT_CURRENCY_FOR_EURO_OR_USD;

  const [activeModal, setActiveModal] = useState(firstModalId);
  const [sliderValue, setSliderValue] = useState<number>(
    defaultCurrentCurrency
  ); // Default slider value
  const [isFailed, setIsFailed] = useState<boolean>(false);

  const [transactionId, setTransactionId] = useState<string>("");

  const handlePaymentSuccess = useCallback(
    (event: MessageEvent) => {
      const data = event.data;

      try {
        const url = new URL(data);
        const responseParam = url.searchParams.get("response");
        const transId = url.searchParams.get("t") || "";

        if (responseParam) {
          const responseObj = JSON.parse(responseParam);

          if (responseObj.status === "error") {
            console.error("!!!Payment Error:", responseObj.message);
            setIsFailed(true);
          } else if (responseObj.status === "success" && transId && !isFailed) {
            setTransactionId(transId);
            setActiveModal("thanks-form-modal");
          }
        } else if (transId && !isFailed) {
          setTransactionId(transId);
          setActiveModal("thanks-form-modal");
        }
      } catch (error) {
        console.error("Error parsing response:", error);
      }
    },
    [isFailed]
  );

  useEffect(() => {
    window.addEventListener("message", handlePaymentSuccess, false);

    return () => {
      window.removeEventListener("message", handlePaymentSuccess, false);
    };
  }, [handlePaymentSuccess]);

  return (
    <>
      {activeModal === "amount-for-thanks" && (
        <DonationModal
          sliderValue={sliderValue}
          setSliderValue={setSliderValue}
          setActiveModal={setActiveModal}
        />
      )}
      {activeModal === "complete-purchase" && (
        <PurchaseModal
          currentCurrency={currentCurrency}
          sliderValue={sliderValue}
          setActiveModal={setActiveModal}
          firstModalId={firstModalId}
          activeModal={activeModal}
          isFailed={isFailed}
          setIsFailed={setIsFailed}
        />
      )}
      {activeModal === "thanks-form-modal" && (
        <ThanksFormModal trId={transactionId} />
      )}
    </>
  );
};

export default ThanksActionModals;
